import { render, staticRenderFns } from "./sectionTitle.vue.html?vue&type=template&id=b40e1234&"
import script from "./sectionTitle.ts?vue&type=script&lang=ts&"
export * from "./sectionTitle.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports